import React from "react";

const CardSkeleton = () => {
  return (
    <div className="flex w-full animate-pulse items-start gap-6 rounded-lg border border-gray-200 p-4 shadow-md">
      <div className="h-7 w-7 rounded-sm bg-gray-300"></div>
      <div className="w-[70%]">
        <div className="mb-2 h-6 w-3/4 rounded bg-gray-300"></div>
        <div className="mb-4 h-4 w-1/2 rounded bg-gray-300"></div>
        <div className="mb-2 h-4 w-1/2 rounded bg-gray-300"></div>
        <div className="mb-2 h-4 w-3/4 rounded bg-gray-300"></div>
        <div className="h-4 w-1/4 rounded bg-gray-300"></div>
      </div>
      <div className="h-5 w-5 rounded-sm bg-gray-300"></div>
    </div>
  );
};

export default CardSkeleton;
